export default __webpack_public_path__ + "static/media/zip.e6aeed99.svg";